/**
 * Franwell brand config (default brand).
 * Keep only copy / theme / contact differences here ? no business logic.
 */
export default {
  id: 'franwell',
  name: 'Franwell',
  companyName: 'Franwell Information Technology (Hongkong) Co., Limited',
  companyAddress:
    'Unit 08, 15/F, Witty Commercial Building, 1A-1L Tung Choi Street, Kowloon, Hong Kong.',
  companyRegNo: '3129940',
  phone: '+86 0512-67678962',
  email: 'fish.xu@franwell.com',
  supportEmail: 'wujie@franwell.com',
  websiteHost: 'm.franwell.com.cn',
  founded: '2022',
  copyrightYear: '2025',
  /** logo filename relative to VUE_APP_IMG_BASE_URL */
  logoFile: 'logo.png',
  favicon: 'favicon.ico',
  theme: {
    primary: '#ff6b22',
    primaryStart: '#ff6b22',
    primaryEnd: '#ff3c61',
    primaryDisabledStart: '#fd9a68',
    primaryDisabledEnd: '#fe7088',
    pageBg: '#f5f5f5',
    bodyBg: '#f6f6f6',
  },
};
